module.exports = __webpack_public_path__ + "static/media/vf_mknit_core.f39e6a67.svg";